import(/* webpackMode: "eager" */ "/home/ubuntu/download/696a6aed1beda80014347c39/kendalportfolio/src/app/not-found.tsx");
